import type { QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { patchTicketCreate } from "@sd/lib/patchTicketCreate";
import { serviceDeskFormilyTicketGridQueryKey } from "@sd/services/APIs";

/**
 * PATCH `/service_desk/ticket_create/{id}/` with `priority_id` (UUID from priority_listing).
 * API stores priority via `priority_id`; `priority` text field stays null.
 */
export async function putTicketPriorityId(
  queryClient: QueryClient,
  ticketId: string,
  priorityId: string
): Promise<boolean> {
  try {
    const ok = await patchTicketCreate(queryClient, ticketId, {
      priority_id: priorityId,
    });
    if (!ok) {
      toast.error("Priority could not be saved.");
      return false;
    }

    await queryClient.invalidateQueries({
      queryKey: serviceDeskFormilyTicketGridQueryKey,
    });

    return true;
  } catch {
    toast.error("Priority could not be saved.");
    return false;
  }
}
